import { compose, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';

import { getCoordinatesFromCountryCode } from 'shared/helpers/coordinates';
import Map from '../components/Map';
import { fetchHomes, fetchShapes } from '../helpers';

const MapContainer = compose(
  withProps(({ countryCode }) => ({
    fetchHomes,
    fetchShapes,
    countryCoordinates: getCoordinatesFromCountryCode(countryCode)
  })),
  withTranslation()
)(Map);

export default MapContainer;
